<template>
  <v-app>
    <v-main>
      <v-app-bar absolute color="teal lighten-2" dark elevate-on-scroll scroll-target="#scrolling-techniques-7">
      <v-toolbar-title>Dialog annotation</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <Tool/>
  </v-main>
  </v-app>
</template>

<script>

import Tool from './components/Tool.vue';

export default {
  name: 'App',

  components: {
    Tool,
  },

  data: () => ({
    //
  }),
};
</script>
